module.exports = __webpack_public_path__ + "static/media/screenshot-04.19bb612d.jpg";